<div class="modal-header">
    <button type="button" class="close-button" (click)="closeModal()">x</button>
</div>
<iframe #pdfViewer class="full-width"></iframe>